import {TbTarget} from "react-icons/tb"
import './GameScore.css'
import {useGameStore} from '../stores/gameStore.js'
import {useEffect, useRef} from 'react'
import {addEffect} from '@react-three/fiber'
import {gsap} from 'gsap'

export function GameScore() {
    const score = useGameStore(state => state.score)
    const endGame = useGameStore(state => state.endGame)
    const resetGame = useGameStore(state => state.resetGame)
    // const gameState = useGameStore(state => state.gameState)

    const timeRef = useRef(null)
    const gameScoreRef = useRef(null)

    const animateOpen = (targetElement) => {
        console.log('animating open gamescore LALALLALAL')
        const timeline = gsap.timeline({
            defaults: {duration: 0.75, ease: 'power3.inOut'},
        })
        timeline.to(targetElement, {
            duration: 0.75,
            x: 250,
            ease: 'power3.inOut',
        });
    }

    const animateClose = () => {
        const timeline = gsap.timeline({
            defaults: {duration: 0.75, ease: 'power3.inOut'},
        })
        timeline.to(gameScoreRef.current, {
            duration: 0.75,
            x: 0,
            ease: 'power3.inOut',
        });
    }

    const handleExitGame = () => {
        animateClose()
        endGame()
        const timer = setTimeout(() => {
            resetGame()
        }, 1000)
        return () => clearTimeout(timer)

    }


    useEffect(() => {
        // Ensure the panel is initially set to its "closed" state via CSS
        // or reset it here before animating open if necessary.
        // For simplicity, assuming CSS handles initial closed state (opacity: 0, scale: 0.85, pointer-events: none)
        if (gameScoreRef.current) {
            // Immediately set to closed state before animating open,
            // especially important if switching panel types.
            // gsap.set(gameScoreRef.current, {opacity: 0, scale: 0.85, pointerEvents: 'none'});
            animateOpen(gameScoreRef.current);
        }
    }, []); // Rerun when data (which includes id) changes

    useEffect(() => {

        const unsubscribeEffect = addEffect(() => {
            const state = useGameStore.getState()

            let elapsedTime = 0.00
            // console.log('GameState:', gameState)
            if (state.gameState === 'playing') {
                elapsedTime = Date.now() - state.startTime
            } else if (state.gameState === 'ended') {
                elapsedTime = state.endTime - state.startTime
            }

            elapsedTime /= 1000
            const formattedTime = elapsedTime.toFixed(1); // Store the formatted string

            if (timeRef.current) {
                timeRef.current.textContent = `${formattedTime}s`; // Use the formatted string
            }
        })
        return () => {
            unsubscribeEffect()
        }
    }, [])


    return (
        <div ref={gameScoreRef} className='game-score-panel'>
            <div className='game-score-container'>
                <div ref={timeRef} className='game-timer'>0.00s</div>
                <p className='game-score'>{score}</p>
                <TbTarget className='target-icon'/>
            </div>
            <div className='exit-game' onClick={handleExitGame}>
                <p>Exit game</p>
            </div>
        </div>
    )
}